import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import { isIPhoneXApp } from 'utils/device'

const BaseLayoutAppBarStyles = theme => ({
  root: {
    width: '100%',
    maxWidth: 1200,
    marginTop: isIPhoneXApp ? theme.spacing.unit * 4 : 0,
    margin: 'auto',
  },
})

const BaseLayoutAppBarBase = ({ classes, children }) => (
  <AppBar position="static" color="inherit" elevation={0}>
    <Toolbar className={classes.root}>
      { children }
    </Toolbar>
  </AppBar>
)

BaseLayoutAppBarBase.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any
}

export const BaseLayoutAppBar = withStyles(BaseLayoutAppBarStyles)(BaseLayoutAppBarBase)

const BaseLayoutContentStyles = theme => ({
  root: {
    overflow: 'hidden',
    minHeight: '100vh',
    padding: theme.spacing.unit * 2,
    // marginTop: isIPhoneXApp ? -theme.spacing.unit * 10 : -theme.spacing.unit * 6,
    // paddingTop: theme.spacing.unit * 9,
    // paddingBottom: theme.spacing.unit * 8,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing.unit * 3,
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit * 12,
      margin: 'auto',
      maxWidth: 1200,
    },
  },
})

const BaseLayoutContentBase = ({ classes, children }) => (
  <div className={classes.root}>
    { children }
  </div>
)

BaseLayoutContentBase.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any
}

export const BaseLayoutContent = withStyles(BaseLayoutContentStyles)(BaseLayoutContentBase)
